'use client';

import { useEffect } from 'react';
import Script from 'next/script';
import { deemaTracker } from '@/components/deema/utils';
import { ValidatedScripts } from '../response-data-validator';
interface Props {
  deemaData: ValidatedScripts['deema'];
}
export const DeemaScript = ({
  deemaData
}: Props) => {
  const isEnabled = deemaData?.enabled;
  useEffect(() => {
    if (!isEnabled) return;
    deemaTracker.detectVisitFromURL();
  }, [isEnabled]);
  if (!isEnabled) return null;
  const {
    scriptUrl
  } = deemaData.config;
  if (!scriptUrl) return null;
  return <Script strategy='lazyOnload' defer src={scriptUrl} data-sentry-element="Script" data-sentry-component="DeemaScript" data-sentry-source-file="deema.tsx" />;
};